export default {

	async page_list () {

		const [ company_dbs, companies, company_groups ] = await Promise.all([
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.CompanyGroupList.fetch()
		])

		await Anvil.renderPage('/c_order/company_db/page_list', { company_dbs, companies, company_groups })
	},

	async action_refresh () {

		const [ company_dbs, companies, company_groups ] = await Promise.all([
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.CompanyGroupList.fetch()
		])

		Anvil.page.company_dbs = company_dbs
		Anvil.page.companies = companies
		Anvil.page.company_groups = company_groups
		Anvil.models.components.Grid.find('#company_db_grid').list = company_dbs
	},

	async modal_edit (id) {

		const [ company_db, companies ] = await Promise.all([
			Anvil.models.c_order.CompanyDB.fetch(id),
			Anvil.models.CompanyList.fetch()
		])

		await Anvil.modal('/c_order/company_db/modal_edit', { company_db, companies })
	},

	async action_save (company_db) {

		// Tell the record to commit
		await company_db.record.commit()

		Anvil.toast.success('Elmentve', 'Az adatbázis adatainak mentése sikeres')

		return true
	},

	async action_delete (id, confirm = false) {

		// Megerősítés kérése
		if (!confirm) {
			Anvil.confirm({
				title: 'Törlés megerősítése',
				message: '<p>Valóban törölni szeretné a kijelölt adatbázist a nyilvántartásból?</p>',
				btn_ok: '<i class="fas fa-trash me-2"></i>Törlés',
				btn_ok_class: 'danger',
				btn_cancel: '<i class="fas fa-times me-2"></i>Mégsem',
				onclose: (confirmed) => {
					if (confirmed) {
						Anvil.exec('c_order/company_db/action_delete', id, true)
					}
				}
			})
			return
		}

		await Anvil.models.c_order.CompanyDB.delete(id)

		Anvil.toast.success('Törölve', 'Az adatbázis nyilvántartásból való törlése sikeres')

		// Refresh list
		await this.action_refresh()
	},

	async action_get_sign_in_token (db_name) {

		const res = await Anvil.REST.get(`/c_order/company_db/${db_name}/sign_in_token`)
		if (!res.success) {
			throw new Error('Sikertelen token lekérés')
		}

		return res.token
	},

	async page_product_audit () {

		const [ res, companies, company_dbs ] = await Promise.all([
			Anvil.REST.get(`/c_order/company_db/product_audit`),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch()
		])

		if (!res.success) {
			throw new Error('Sikertelen termék audit lekérés')
		}

		const list = res.payload.data

		await Anvil.renderPage('/c_order/company_db/page_product_audit', { companies, company_dbs, list })
	}
}
